module.exports = __webpack_public_path__ + "assets/101971b3e100f6f829ccc1e015666c6a.png";